// e.g. converts ['events', '12', 'edit'] to /events/12/edit
export const addSlashes = (...segments: string[]) => "/" + segments.join("/");

// Add /company to urls
export const withCompanyPrefix = (url: string) => {
  const cleanUrl = url.startsWith("/") ? url.slice(1) : url;
  return `/company/${cleanUrl}`;
};
